import { serverConfig } from '@/config/server.config'
import type { LogoutResponse } from '@/types/authentication'

export async function logout(): Promise<LogoutResponse> {
  const response = await fetch(
    `${serverConfig.digitalCommunicationsApiUrl}/authentication/logout`,
    {
      method: 'POST',
      credentials: 'include',
    },
  )
  if (!response.ok) {
    throw new Error('Failed to logout')
  }

  return response.json()
}
